import { render } from "./EditQualificationEducation.vue?vue&type=template&id=10728904"
import script from "./EditQualificationEducation.vue?vue&type=script&lang=js"
export * from "./EditQualificationEducation.vue?vue&type=script&lang=js"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__